import { onLocationLayerLeave, onPropertyLayerLeave } from './mouse';

const onExit = ( ctx, event ) => {
    onLocationLayerLeave( ctx, event );
    onPropertyLayerLeave( ctx, event );
};

export default onExit;
